"use client"
import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function PlusIcon(props: Props) {
  const { t } = useLingui()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <title>{t`Plus Icon`}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 3C8.75 2.58579 8.41421 2.25 8 2.25C7.58579 2.25 7.25 2.58579 7.25 3V7.25H3C2.58579 7.25 2.25 7.58579 2.25 8C2.25 8.41421 2.58579 8.75 3 8.75H7.25V13C7.25 13.4142 7.58579 13.75 8 13.75C8.41421 13.75 8.75 13.4142 8.75 13V8.75H13C13.4142 8.75 13.75 8.41421 13.75 8C13.75 7.58579 13.4142 7.25 13 7.25H8.75V3Z"
        fill="currentColor"
      />
    </svg>
  )
}
